function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * gets the sum of all items in all previous groups, in order
 */
const getAllPreviousGroupCounts = groupedItems => {
  const allCounts = groupedItems.reduce((acc, curr) => {
    const currentCount = curr.items.length;
    acc.counts.push(acc.total);
    acc.total += currentCount;
    return acc;
  }, {
    counts: [],
    total: 0
  });
  return allCounts.counts;
};
export const getStartingIndices = groupedItems => {
  const groupCounts = getAllPreviousGroupCounts(groupedItems);
  return groupedItems.reduce((indices, _, index) => {
    if (index === 0) {
      // the first group will always map to the first item
      return indices.set(0, 0);
    }
    return indices.set(index, groupCounts[index]);
  }, new Map());
};

/**
 * Strips the grouping out of dropdown items, transforming them into items, including a dummy item for the group header.
 * THESE ARE NOT REFERENCE EQUAL TO THE PROVIDED ITEMS.
 * @param groupedItems The grouped dropdown items
 * @param startingIndices The indicies that the group should start at, in the format [groupIndex, firstItemIndex]
 * @returns flattened items without any context of grouping
 */
export const flattenGroupItemsToNonDownshift = (groupedItems, startingIndices) => groupedItems.reduce((prev, curr, groupIndex) => {
  const groupKey = "group".concat(groupIndex);
  const groupHeader = {
    label: curr.label,
    groupKey,
    isGroupHeader: true
  };
  prev.push(groupHeader);
  curr.items.forEach((item, itemIndex) => prev.push(_objectSpread(_objectSpread({}, item), {}, {
    index: (startingIndices.get(groupIndex) || 0) + itemIndex,
    groupKey
  })));
  return prev;
}, []);
export const areGroupedItems = maybeGroupedItems => {
  const unsafeMaybeGroupedItems = maybeGroupedItems;
  return unsafeMaybeGroupedItems[0] && !!unsafeMaybeGroupedItems[0].items;
};

/**
 * Strips the grouping out of dropdown items
 * @param groupedItems The grouped dropdown items
 * @returns flattened items without any context of grouping
 */
export const flattenGroupItemsToDownshift = maybeGroupedItems => areGroupedItems(maybeGroupedItems) ? maybeGroupedItems.reduce((result, group) => {
  result.push(...group.items);
  return result;
}, []) : maybeGroupedItems;
//# sourceMappingURL=groupedItems.js.map